//Nurbs custom code
function nurbslink(obj){
    window.location.href = "https://experience-handcraftd.co/?id="+obj ;
}

if(typeof nurbs_productInfo !== 'undefined'){
    for (let tag of nurbs_productInfo.tags) {
        if(tag === 'Model' || tag === 'Visualize'){
            let elements = document.querySelectorAll("form[action$='/cart/add']");
            //console.log(nurbs_productInfo);
            //console.log(nurbs_label_or_text);
            //console.log(elements);
            new_element = document.querySelectorAll("form[action$='/cart/add']")[1];
            new_element = new_element.parentElement;
            //console.log(new_element);
            className = 'product-form';
            if(tag === 'Model'){
                var styleElem = document.head.appendChild(document.createElement("style"));
                styleElem.innerHTML = ".nurbs-css:before {background: #000000;}";
                //element.innerHTML = "<button type='button' class='"+className+" """+str(styleButton)+""" nurbs-css shopify-payment-button__button shopify-payment-button__button--unbranded' onClick='nurbslink(nurbs_productInfo.id)' style='background-color:"""+color+""";color: white;border-color: white;' class='"+className+"' data-testid='Checkout-button'>"+nurbs_label_text+"</button>";
                //new_element.innerHTML += "<p style='text-align: center'>"+nurbs_label_or_text+"</p>";
                new_element.innerHTML = "<button type='button' class='"+className+" nurbs-css shopify-payment-button__button shopify-payment-button__button--unbranded' onClick='nurbslink(nurbs_productInfo.id)' style='background-color: #000000;color: white;border-color: white;' class='"+className+"' data-testid='Checkout-button'>"+nurbs_label_text+"</button>";
                const hideWidgets = () => {
                    document.querySelectorAll('.vtl-pl-main-widget').forEach(el => {
                        el.style.display = 'none';
                    });
                    };

                    hideWidgets(); // Nasconde subito

                    // Osserva il DOM in cerca di nuovi elementi
                    const observer = new MutationObserver(hideWidgets);

                    observer.observe(document.body, {
                    childList: true,
                    subtree: true
                    });
                break; 
            }else if(tag === 'Visualize'){
                var styleElem = document.head.appendChild(document.createElement("style"));
                styleElem.innerHTML = ".nurbs-css:before {background: #000000;}";
                new_element.innerHTML += "<p style='text-align: center'>"+nurbs_label_or_text+"</p>";
                new_element.innerHTML += "<button type='button' class='  nurbs-css shopify-payment-button__button shopify-payment-button__button--unbranded' onClick='nurbslink(nurbs_productInfo.id)' style='background-color: #000000;color: white;border-color: white;' class='"+className+"' data-testid='Checkout-button'>"+nurbs_label_visualize_only_text+"</button>";
                break;
            }
        }
    }
}